import React, { useEffect, useState } from "react";

// pending to download
// All other redirect to page dashboard

import ApiService from "../../services/ApiService";
import "../../assets/scss/pages/quiz.scss";
import { Container, Row, Col } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import VideoJS from "../videoPlayer/VideoJS";
import Loader from "../../features/Loader";
import logoFull from "./../../assets/images/video-logo.png";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { FaAngleUp, FaAngleDown } from "react-icons/fa6";

import LearningQuiz from "../../components/LearningQuiz/LearningQuiz";
import {
  callAlert,
  callAlertConfirm,
  downloadPdfFile,
  secondsToHms,
} from "../../services/CommonService";
import { MdAssignment, MdOndemandVideo, MdOutlineQuiz } from "react-icons/md";
import ConfigService from "../../services/ConfigService";
import Modal from "react-bootstrap/Modal";
import { IconBase } from "react-icons/lib";
import { FaPause, FaPauseCircle, FaPlay } from "react-icons/fa";

export default function Learning() {
  const { id } = useParams();
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [course, setCourse] = useState();
  const [videoTitle, setVideoTitle] = useState("Introduction");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState(null);
  const [videoTypeLang, setVideoTypeLang] = useState("English");
  const [videoJsOptions, setVideoJsOptions] = useState();
  const [currentArr, setCurrentArr] = useState();
  const [currentQuizArr, setCurrentQuizArr] = useState();
  //const [courseProgress, setCourseProgress] = useState();
  const [show, setShow] = useState(false);
  const [thanksStatus, setThanksStatus] = useState(false);
  const [thanksStatusQuiz, setThanksStatusQuiz] = useState(false);
  const [isExpired, setIsExpired] = useState(false);

  //'http://138.201.249.173:4700/icse-class-9/cl9mod2session2_edited.m3u8'

  const playerRef = React.useRef(null);
  const [type, setType] = useState("video");
  const [quizData, setQuizData] = useState();
  const [currentStatus, setCurrentStatus] = useState("video");

  const [videoId, setVideoId] = useState("");

  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const source = params.get("videoId");

    if (source) {
      setVideoId(source);
      console.log(source);
    }
  }, [location.search]);

  const toggleCollapse = () => {
    if (activeKey === "null") {
      setActiveKey("0");
    } else {
      setActiveKey("null");
    }
  };

  const [allCollapsed, setAllCollapsed] = useState(true);
  const [courseUpdate, setCourseUpdate] = useState(true);
  const [activeKeys, setActiveKeys] = useState([]);

  const [userDetails, setUserDetails] = useState(false);
  useEffect(() => {
    let userDetailss = localStorage.getItem("userDetails");
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
    }
  }, []);

  const scrollToId = (id) => {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    setTimeout(() => scrollToId("learning-view"), 1000); // wait for DOM render
  }, []);

  const handleClose = () => {
    callAlertConfirm(
      "",
      "Are you sure you want to cancel quiz?",
      (result) => {
        if (result.isConfirmed) {
          fetchData(currentArr.courseIndex, currentArr.videoIndex);
          setCurrentStatus("video");
          setShow(false);
        } else if (result.isDenied) {
          return false;
        }
      },
      false,
    );
  };

  // useEffect(() => {
  //   if (course && course.courseModules) {
  //     setActiveKeys(course.courseModules.map(() => allCollapsed));
  //   }
  // }, [course, allCollapsed]);
  useEffect(() => {
    // if (course && course.courseModules) {
    //   setActiveKeys([]); // all collapsed initially
    // }
    if (course && course.courseModules && activeKeys.length === 0) {
      setActiveKeys([]); // only first time
    }
  }, [course]);

  // const toggleCollapseAll = () => {
  //   setAllCollapsed(!allCollapsed);
  //   setActiveKeys(activeKeys.map(() => !allCollapsed));
  // };

  //   const toggleCollapseAll = () => {
  //   setAllCollapsed((prev) => {
  //     const newState = !prev;

  //     if (newState) {
  //       // 👉 Collapse all
  //       setActiveKey(null);
  //     } else {
  //       // 👉 Expand all (open first one OR all not possible in your current setup)
  //       setActiveKey("0"); // open first accordion
  //     }

  //     return newState;
  //   });
  // };
  const toggleCollapseAll = () => {
    // setAllCollapsed((prev) => {
    //   const newState = !prev;

    //   if (newState) {
    //     // collapse all
    //     setActiveKeys([]);
    //   } else {
    //     // expand all
    //     setActiveKeys(course.courseModules.map((_, i) => i.toString()));
    //   }

    //   return newState;
    // });
    if (activeKeys.length > 0) {
      // 👉 If anything is open → collapse all
      setActiveKeys([]);
    } else {
      // 👉 If all are closed → expand all
      setActiveKeys(course.courseModules.map((_, i) => i.toString()));
    }
  };

  // const handleToggle = (key) => {
  //   setActiveKey(activeKey === key ? null : key);
  // };

  const handleToggle = (key) => {
    setActiveKeys(
      (prev) =>
        prev.includes(key) ?
          prev.filter((k) => k !== key) // close
        : [...prev, key], // open
    );
  };

  const changeLang = (value) => {
    setVideoTypeLang(value);
    console.log(videoTypeLang);
    setLoaderStatus(true);
    setTimeout((d) => {
      console.log(videoTypeLang);
      setVideoJsOptions(
        createVideoObj(
          currentArr,
          `${currentArr.value}`,
          value,
          "English",
          false,
          currentArr.courseIndex,
          currentArr.videoIndex,
        ),
      );

      setLoaderStatus(false);
    }, 1000);
  };
  function transformM3U8Url(originalUrl) {
    // Extract parts of the URL
    const url = new URL(originalUrl);
    const pathParts = url.pathname.split("/");

    // Get filename without extension
    const fileName = pathParts.pop(); // e.g., Cl10mod1Session1.m3u8
    const nameOnly = fileName.replace(".m3u8", "");

    // Add folder with same name
    pathParts.push(nameOnly);
    pathParts.push(fileName);

    // Rebuild the full URL
    url.pathname = pathParts.join("/");

    return url.href;
  }
  function replaceLastComma(str, replacement) {
    const lastIndex = str.lastIndexOf("/");

    if (lastIndex === -1) {
      return str; // No comma found, return the original string
    }

    const updated = transformM3U8Url(
      str.substring(0, lastIndex) + replacement + str.substring(lastIndex + 1),
    );

    return updated;
  }

  const createVideoObj = (
    content,
    videoSrc,
    videoLang = "English",
    autoplay = false,
    moduleIndexs = 0,
    videoIndex = 0,
  ) => {
    videoSrc = `${ConfigService.VIDEO_URL}${videoSrc.replace("videos/", "")}`;

    if (videoLang == "Hindi") {
      videoSrc = replaceLastComma(videoSrc, "/hi/");
    } else {
      videoSrc = replaceLastComma(videoSrc, "/en/");
    }

    setCurrentArr({
      courseIndex: moduleIndexs,
      videoIndex: videoIndex,
      ...content,
    });

    return {
      autoplay: autoplay,
      poster: logoFull,
      width: 600,
      height: 300,
      language: "es",
      sources: [
        {
          src: videoSrc,
          withCredentials: false,
        },
      ],
      html5: {
        vhs: {
          withCredentials: false,
        },
        nativeAudioTracks: true,
        nativeVideoTracks: true,
        nativeTextTracks: true,
      },
    };
  };

  const findVideoIndexes = (courseModules, videoId) => {
    for (let mIndex = 0; mIndex < courseModules.length; mIndex++) {
      const module = courseModules[mIndex];

      for (let vIndex = 0; vIndex < module.contentList.length; vIndex++) {
        const video = module.contentList[vIndex];

        if (video.id.toString() === videoId.toString()) {
          return {
            moduleIndex: mIndex,
            videoIndex: vIndex,
          };
        }
      }
    }

    return { moduleIndex: 0, videoIndex: 0 }; // fallback
  };

  const fetchData = async (moduleIndexs = 0, videoIndex = 0, type = "") => {
    console.log(moduleIndexs, videoIndex, type);
    try {
      const response = await ApiService.publicGetRequest(
        `/subscription/selectedcourse?courseid=${id}`,
        true,
      );

      if (response.data.data.length !== 0) {
        // setCourseProgress(response.data.data.courseProgress);
        //let courseProgres=response.data.data.courseProgress

        // ── Expiry check ──────────────────────────────────────────────
        const expiryDate = response.data.data.expiryDate;
        if (expiryDate) {
          const now = new Date();
          const expiry = new Date(expiryDate);
          setIsExpired(expiry < now);
        }
        // ─────────────────────────────────────────────────────────────

        const course = response.data.data.course;
        const lastViewedName = response.data.data.lastViewed;
        course.courseModules.forEach((dd, mIndex) => {
          dd.contentList = dd.contentList.sort((a, b) => a.index - b.index);

          dd.contentList.forEach((d, vIndex) => {
            d["checked"] = false;
            if (d?.videoProgress) {
              //d['completed']=(courseProgres[d.name]*100/d.duration);
              d["completed"] = (d?.videoProgress * 100) / d.duration;

              if (
                d["completed"] > 99 &&
                d?.quiz &&
                d.quizProgress == "COMPLETE"
              ) {
                d["checked"] = true;
              }
            }

            // if (type == "load") {
            //   if (lastViewedName == d.name) {
            //     moduleIndexs = mIndex;
            //     videoIndex = vIndex;
            //   }
            // }
            if (type === "load" && response.data.data.lastViewed) {
              const indexes = findVideoIndexes(
                course.courseModules,
                response.data.data.lastViewed,
              );

              setActiveKeys([indexes.moduleIndex.toString()]);
              setAllCollapsed(false);
              moduleIndexs = indexes.moduleIndex;
              videoIndex = indexes.videoIndex;
            }

            /*  if(d?.quiz && d.quizProgress && d?.quizProgress[d.quiz]){  
                          d['quizReport']=true;
                            }  */
          });
        });
        setCourse(course);

        setVideoTitle(
          `${course?.courseModules[moduleIndexs]?.name} / ${course?.courseModules[moduleIndexs].contentList[videoIndex].name}`,
        );
        console.log(videoTitle, moduleIndexs, videoIndex, course);

        setVideoJsOptions(
          createVideoObj(
            course?.courseModules[moduleIndexs].contentList[videoIndex],
            `${course?.courseModules[moduleIndexs].contentList[videoIndex].value}`,
            "English",
            false,
            moduleIndexs,
            videoIndex,
          ),
        );
      }

      setLoaderStatus(false);
    } catch (error) {
      console.error("Error fetching courses:", error);
      /*  setError({
        message: "Course not found",
        url: window.location.href,
      }); */
    }
  };
  useEffect(() => {
    fetchData(0, 0, "load");
  }, []);

  useEffect(() => {
    if (error) {
      navigate("/custom-error", { state: { error: error && error } });
    }
  }, [error, navigate]);

  const handlePlayerReady = (player) => {
    playerRef.current = player;

    if (currentArr?.videoProgress) {
      if (currentArr?.completed < 100) {
        player.currentTime(
          currentArr.videoProgress ? currentArr.videoProgress : 1,
        );
      }
    }

    // You can handle player events here, for example:
    player.on("play", () => {
      setThanksStatus(false);
      setThanksStatusQuiz(false);
      console.log("player is play");
      intervalIdfn("start", player);
    });

    player.on("timeupdate", () => {});

    player.on("stop", () => {
      console.log("player is stop");
      intervalIdfn("clear");
    });
    player.on("pause", () => {
      console.log("player is pause");
      intervalIdfn("clear");
    });

    player.on("waiting", () => {
      //VideoJS.log("player is waiting");
    });

    player.on("dispose", () => {
      // VideoJS.log("player will dispose");
    });

    /* player.languageSwitch({
            languages: [
              {
                name: 'English',
                sources: [
                  {
                    src: 'http://bit.ly/2iJXRec',
                    type: 'video/mp4',
                    res: 'Medium'
                  },
                  {
                    src: 'http://bit.ly/2jxmfwI',
                    type: 'video/webm',
                    res: 'Medium'
                  }
                ]
              },
              {
                name: 'Portuguese',
                sources: [
                  {
                    src: 'http://bit.ly/2jVlmho',
                    type: 'video/mp4',
                    res: 'Medium'
                  },
                  {
                    src: 'http://bit.ly/2jVlTzx',
                    type: 'video/webm',
                    res: 'Medium'
                  }
                ]
              }
            ],
            positionIndex: 15
          }) */

    player.on("ended", () => {
      console.log("ended");
      // setType("step1");
      setThanksStatus(true);
      setTimeout((d) => {
        setThanksStatus(false);
      }, 120000);
      if (videoTypeLang != "Hindi") {
        if (player && player?.currentTime()) {
          updateVideoProgress(
            currentArr.id,
            currentArr.name,
            player?.currentTime() ? player?.currentTime() : "",
          );
        }
        if (currentArr.quizProgress != "COMPLETE" && currentArr.quiz) {
          setThanksStatusQuiz(true);
          //handleOnClick(currentArr, currentArr, "quiz");
        }
      }
    });
  };

  var intervalId;
  const intervalIdfn = (type = "start", player = null) => {
    if (intervalId) {
      clearInterval(intervalId);
    }

    if (type == "clear") {
      return;
    }

    intervalId = setInterval((d) => {
      if (videoTypeLang != "Hindi") {
        //if (player.prototype?.isPrototypeOf(player.currentTime)) {
        try {
          if (player && player?.currentTime()) {
            updateVideoProgress(
              currentArr?.id,
              currentArr?.name,
              player?.currentTime() ? player?.currentTime() : "",
            );
          }
        } catch (error) {}
      }
      //update video time
    }, 10000);
  };
  const updateVideoProgress = (videoId, videoName, times) => {
    /*   if(d?.videoProgress){ 
            //d['completed']=(courseProgres[d.name]*100/d.duration);
            d['completed']=(d?.videoProgress*100/d.duration);
              }  */

    course.courseModules.forEach((dd) => {
      dd["contentList"].forEach((d) => {
        if (d.name == currentArr.name) {
          d["videoProgress"] = times;
          d["completed"] = (times * 100) / d.duration;

          if (d["completed"] > 99 && d?.quiz && d.quizProgress == "COMPLETE") {
            d["checked"] = true;
          } else {
            d["checked"] = false;
          }

          setCourseUpdate(false);
          setCourse(course);

          setTimeout((d) => {
            setCourseUpdate(true);
          }, 10);
        }
      });
    });

    if (times) {
      ApiService.publicPostRequest(
        "/progress/updateprogress",
        {
          courseId: course.courseId,
          videoId: videoId, //videoId,
          addTime: times,
          videoName: videoName,
        },
        true,
      )
        .then((res) => {})
        .catch((error) => {
          callAlert("", error?.error?.message);
        });
    }
  };

  const outputDatafn = (d) => {
    if (d === "cancelQuiz") {
      setCurrentStatus("video");
      console.log(currentArr, "currentArrcurrentArr");

      fetchData(currentArr.courseIndex, currentArr.videoIndex);
      setShow(false);
    }
  };
  const handleOnClick = (
    content,
    chapterName,
    type = "video",
    index = 0,
    videoIndex = 0,
  ) => {
    intervalIdfn("clear");
    setLoaderStatus(true);
    if (type === "video") {
      setTimeout((d) => {
        setCurrentStatus(type);
        setType(type);
        setVideoJsOptions(
          createVideoObj(
            content,
            `${content.value}`,
            "English",
            true,
            index,
            videoIndex,
          ),
        );
        setVideoTitle(`${chapterName} / ${content.name}`);
        setLoaderStatus(false);
      }, 500);
    } else {
      setShow(true);

      setCurrentQuizArr({
        courseIndex: index,
        videoIndex: videoIndex,
        ...content,
      });

      setTimeout((d) => {
        setType("step1");
        setCurrentStatus(type);
        setVideoTitle(`${chapterName}`);

        console.log(course);
        let courseModules = course["courseModules"][index];
        setQuizData({
          courseId: course.courseId,
          modulesId: courseModules["id"],
          videoId: courseModules["contentList"][videoIndex]["id"],
          quiz: content.quiz,
          videoName: content.name,
          courseName: course.courseName,
          courseIndex: index,
          videoIndex: videoIndex,
          moduleName: chapterName,
        });
        setLoaderStatus(false);
      }, 200);
    }
  };

  const redirectPage = (page) => {
    navigate(`/user/dashboard/${page}`);
    return;
  };

  const downloadFile = (content, courseIndex, videoIndex, chapter) => {
    console.log("Contnet", content);
    // const pdfURL = "/quiz/downloadAssignment/" + content.assignment;
    // const pdfURL = "/file/assignments/downloadAssignment/";
    const pdfURL = "/assignments/downloadAssignment/";
    downloadPdfFile(
      pdfURL,
      content.assignment.replace(".pdf", ""),
      {
        name: content.assignment,
        courseName: course.courseName,
        videoName: content.name,
        moduleName: chapter.name,
      },
      true,
      "POST",
      (d) => {
        fetchData(courseIndex, videoIndex);
      },
    );
  };

  useEffect(() => {
    document.title = "Learning";
  }, []);

  return (
    <>
      <section className="quiz-wrapper pb-5 bg-quiz" id="learning-view">
        <Container>
          <Row>
            <Col sm={8}>
              <div className="card p-2 mt-5">
                {loaderStatus && <Loader />}

                {!loaderStatus && (
                  <>
                    <h3 className="h1 mb-3 mt-2">{videoTitle}</h3>

                    {currentStatus === "video" && videoJsOptions && (
                      <>
                        {userDetails &&
                          userDetails.userLang !== "en" &&
                          userDetails.userLang !== "English" && (
                            <>
                              Select Video Language :{" "}
                              <select
                                value={videoTypeLang}
                                className="  w-25"
                                onChange={async (e) => {
                                  changeLang(e.currentTarget.value);
                                }}
                              >
                                <option value="English">English</option>
                                <option value="Hindi">Hindi</option>
                              </select>
                            </>
                          )}

                        <div className="thanksForWatchig">
                          {thanksStatus && (
                            <span className="displayText">
                              {" "}
                              <span>
                                {" "}
                                Thanks for <br /> watching{" "}
                                {setThanksStatus && (
                                  <div className=" mt-3">
                                    {currentArr.quizProgress != "COMPLETE" &&
                                      currentArr.quiz && (
                                        <>
                                          <span
                                            className={`quiz links   btn text-white  btn-primary
                             ${
                               currentArr.quizProgress == "RETRY" ?
                                 "btn-danger"
                               : ""
                             }
                             ${
                               currentArr.quizProgress == "INPROGRESS" ?
                                 "btn-primary"
                               : ""
                             } 
                           `}
                                            title="Click to open quiz"
                                            onClick={() => {
                                              handleOnClick(
                                                currentArr,
                                                videoTitle,
                                                "quiz",
                                                currentArr.courseIndex,
                                                currentArr.videoIndex,
                                              );
                                            }}
                                          >
                                            {" "}
                                            <MdOutlineQuiz />
                                            {(
                                              currentArr.quizProgress == "RETRY"
                                            ) ?
                                              " Retry "
                                            : " "}
                                            {(
                                              currentArr.quizProgress ==
                                              "INPROGRESS"
                                            ) ?
                                              " Resume "
                                            : " "}
                                            {(
                                              currentArr.quizProgress ==
                                              ("INPROGRESS" || "RETRY")
                                            ) ?
                                              "  "
                                            : " Start "}
                                            Quiz
                                          </span>
                                        </>
                                      )}
                                    {currentArr.quizProgress == "COMPLETE" && (
                                      <>
                                        <span
                                          className=" quiz links  btn btn-success text-white "
                                          onClick={() => {
                                            redirectPage("QUIZ");
                                          }}
                                          title="Click to view quiz report"
                                        >
                                          {" "}
                                          <MdOutlineQuiz /> Go to Quiz Report
                                        </span>
                                      </>
                                    )}
                                  </div>
                                )}
                              </span>
                            </span>
                          )}

                          <VideoJS
                            options={videoJsOptions}
                            onReady={handlePlayerReady}
                          />
                        </div>
                      </>
                    )}

                    {currentStatus === "quiz" && (
                      <>
                        <Modal
                          show={show}
                          onHide={handleClose}
                          fullscreen={true}
                          className="bg-quiz"
                        >
                          <Modal.Header
                            closeButton
                            className="modal-header-quiz"
                          >
                            <Modal.Title>{videoTitle} </Modal.Title>
                          </Modal.Header>
                          <Modal.Body className=" bg-quiz ">
                            <div className="row">
                              <div className="col-md-10 offset-md-1">
                                <LearningQuiz
                                  type={type}
                                  setType={setType}
                                  quizData={quizData}
                                  outputData={outputDatafn}
                                />
                              </div>
                            </div>
                          </Modal.Body>
                        </Modal>
                      </>
                    )}
                  </>
                )}
              </div>
            </Col>
            <Col sm={4}>
              {!course && (
                <div className="card p-2 mt-5">
                  <div className=" ">
                    <Loader />{" "}
                  </div>
                </div>
              )}
              {course && (
                <div className="accoding-container mt-5">

                  {/* ── Expired Banner ───────────────────────────────────── */}
                  {isExpired && (
                    <div
                      className="alert alert-danger d-flex align-items-center gap-2 mb-3"
                      role="alert"
                      style={{ borderRadius: "8px", fontWeight: 500 }}
                    >
                      <span style={{ fontSize: "1.2rem" }}>⚠️</span>
                      <div>
                        <strong>Course Expired</strong>
                        <div style={{ fontSize: "0.85rem", marginTop: "2px" }}>
                          Your access to this course has expired. Please renew
                          your subscription to continue learning.
                        </div>
                      </div>
                    </div>
                  )}
                  {/* ─────────────────────────────────────────────────────── */}

                  <div className="d-flex justify-content-between align-item-center">
                    <h3 className="title-course text-center">Course Content</h3>
                    <button
                      className="btn btn-primary me-3 mt-n1"
                      onClick={toggleCollapseAll}
                    >
                      {/* {allCollapsed ? */}
                      {activeKeys.length > 0 ?
                        <FaAngleUp />
                      : <FaAngleDown />}
                    </button>
                  </div>

                  <div className="card-content1 ">
                    {courseUpdate &&
                      course.courseModules?.map((chapter, index) => (
                        <Accordion
                          activeKey={activeKeys}
                          alwaysOpen
                          // onSelect={() => handleToggle(index.toString())}
                          className="courseSidebarDetails"
                        >
                          {/* <AccordionCustom
                          course={course}
                          chapter={chapter}
                          key={index}
                          index={index}
                          handleOnClick={handleOnClick}
                          activeKey={activeKeys[index]}
                          toggleCollapse={() => handleToggle(index)}
                          fetchData={fetchData}
                        />
                        */}

                          {/* {courseUpdate &&
                        course.courseModules?.map((chapter, index) => ( */}
                          <Accordion.Item eventKey={index.toString()}>
                            <Accordion.Header
                              // className="d-block"
                              className={`courseSidebarDetails ${
                                currentArr?.courseIndex === index ?
                                  "active-module"
                                : ""
                              }`}
                              style={{ margin: "2px" }}
                              onClick={() => handleToggle(index.toString())}
                            >
                              <span className="d-block"> {chapter.name} </span>

                              <span className="d-block time mt-1">
                                {" "}
                                {chapter.contentList.length} Video |{" "}
                                {secondsToHms(
                                  chapter.contentList
                                    .map((d) => d.duration)
                                    .reduce(function (a, b) {
                                      return a + b;
                                    }, 0),
                                )}
                              </span>
                            </Accordion.Header>
                            <Accordion.Body>
                              {chapter.contentList?.map(
                                (content, contentIndex) => (
                                  <>
                                    {/* <div
                                      key={contentIndex}
                                      className=" sidebarSection"
                                    > */}
                                    <div
                                      key={contentIndex}
                                      className={`sidebarSection ${
                                        (
                                          currentArr?.courseIndex === index &&
                                          currentArr?.videoIndex ===
                                            contentIndex
                                        ) ?
                                          "active-video"
                                        : ""
                                      }`}
                                    >
                                      <div className=" row     pb-3 pt-3 ">
                                        <div className=" col-md-1">
                                          {(
                                            currentArr?.courseIndex === index &&
                                            currentArr?.videoIndex ===
                                              contentIndex
                                          ) ?
                                            <FaPause />
                                          : <FaPlay />}
                                          {/* <input
                                            type="checkbox"
                                            // type="play"
                                            // disabled="true"
                                            checked={content?.checked}
                                            name={`chapter-${index}`}
                                            onChange={(e) => {}}
                                          />{" "} */}
                                        </div>
                                        <div className=" col-md-11 ">
                                          <Link
                                            className="fw-bolder d-block"
                                            onClick={() => {
                                              handleOnClick(
                                                content,
                                                chapter.name,
                                                "video",
                                                index,
                                                contentIndex,
                                              );
                                            }}
                                          >
                                            <h3 className="fs-6 mb-2 fw-bolder">
                                              {/*  {contentIndex + 1}. */}{" "}
                                              {content.name}
                                            </h3>{" "}
                                          </Link>

                                          <div
                                            className="progress mt3 mb-2"
                                            style={{ height: 4 }}
                                            title={secondsToHms(
                                              content.videoProgress,
                                            )}
                                          >
                                            <div
                                              className="progress-bar"
                                              role="progressbar"
                                              aria-valuemin="0"
                                              aria-valuemax="100"
                                              style={{
                                                width: content?.completed + "%",
                                              }}
                                            ></div>
                                          </div>
                                          <span
                                            className={`time1 links ${
                                              content?.completed ?
                                                "text-success"
                                              : ""
                                            } `}
                                            onClick={() => {
                                              handleOnClick(
                                                content,
                                                chapter.name,
                                                "video",
                                                index,
                                                contentIndex,
                                              );
                                            }}
                                            title="Click to view video"
                                          >
                                            <MdOndemandVideo />{" "}
                                            {secondsToHms(content.duration)}
                                          </span>

                                          {content.quizProgress != "COMPLETE" &&
                                            content.quiz && (
                                              <>
                                                <span
                                                  className={`quiz links 
                             ${
                               content.quizProgress == "RETRY" ?
                                 "text-danger"
                               : ""
                             } 
                             ${
                               content.quizProgress == "INPROGRESS" ?
                                 "text-primary"
                               : ""
                             } 
                          `}
                                                  title="Click to open quiz"
                                                  onClick={() => {
                                                    handleOnClick(
                                                      content,
                                                      chapter.name,
                                                      "quiz",
                                                      index,
                                                      contentIndex,
                                                    );
                                                  }}
                                                >
                                                  {" "}
                                                  <MdOutlineQuiz />
                                                  {(
                                                    content.quizProgress ==
                                                    "RETRY"
                                                  ) ?
                                                    " Retry"
                                                  : ""}
                                                  {(
                                                    content.quizProgress ==
                                                    "INPROGRESS"
                                                  ) ?
                                                    " Resume "
                                                  : ""}
                                                  Quiz
                                                </span>
                                              </>
                                            )}
                                          {content.quizProgress ==
                                            "COMPLETE" && (
                                            <>
                                              <span
                                                className="quiz links text-success"
                                                onClick={() => {
                                                  redirectPage("QUIZ");
                                                }}
                                                title="Click to view quiz report"
                                              >
                                                {" "}
                                                <MdOutlineQuiz /> Go to Quiz
                                                Report
                                              </span>
                                            </>
                                          )}
                                          {content.assignment == null ?
                                            <></>
                                          : (
                                            content.assignmentProgress ==
                                            "PENDING"
                                          ) ?
                                            <>
                                              <span
                                                className="assignment links text-primary text-nowrap"
                                                onClick={() => {
                                                  downloadFile(
                                                    content,
                                                    index,
                                                    contentIndex,
                                                    chapter,
                                                  );
                                                }}
                                                title="Click to download assignment"
                                              >
                                                <MdAssignment /> Download
                                                Assignment
                                              </span>
                                            </>
                                          : <>
                                              <span
                                                className="assignment links text-info text-nowrap"
                                                onClick={() => {
                                                  redirectPage("ASSIGNMENT");
                                                }}
                                                title="Click to view assignment report"
                                              >
                                                {" "}
                                                <MdOutlineQuiz /> Go to
                                                Assignment Report
                                              </span>
                                            </>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ),
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                      ))}
                  </div>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

function AccordionCustom({
  course,
  chapter,
  index,
  handleOnClick,
  activeKey,
  toggleCollapse,
  fetchData,
}) {
  return (
    <>
      /* <Accordion.Item eventKey="2"></Accordion.Item> */
    </>
  );
}
